import { GetStaticProps, NextPage } from 'next';
import React, { useEffect } from 'react';
import { MetaTagsComp } from '../components/MetaTagsComp';
import SocialResponsibilityComponent from '../components/SocialResponsibility';
import fetchUtil from '../utils/fetchUtil';

const CorporateSocialResponsibilityPage:NextPage = (props:any) => {
    const {meta} = props.pageData;
    useEffect(()=>{
      const customStyle = document.documentElement.style
      customStyle.setProperty('--navbar-color','#6C48F0');
      customStyle.setProperty('--navbar-menu-color','#ffffff');
    },[])
    return (
        <>
           {meta && <MetaTagsComp {...meta}/>}
           <SocialResponsibilityComponent {...props}/>
        </>
    )

}

export const getStaticProps : GetStaticProps = async (context) =>{
    const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/csr-page`, 'GET', {}, '', false)
    return {
        props: { pageData }
      };
}

export default CorporateSocialResponsibilityPage;